/** @jsx h */
import { labels } from '../config';
import { useRef, useEffect } from 'preact/hooks';

const Pagination = ({ pagination, triggerLoadMore, pluginNamespace }) => {
  const paginationInputEl = useRef(null);

  useEffect(() => {
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = '';
    }
  }, []);

  function handleLoadMoreClick(event) {
    event && event.preventDefault();
    if (paginationInputEl && paginationInputEl.current) {
      paginationInputEl.current.value = pagination.currentPage + 1;
      triggerLoadMore();
    }
  }
  /* Only show load more button, if there is something to load */
  if (
    pagination &&
    (pagination.currentPage === pagination.numberOfPages ||
      pagination.numberOfPages === 0)
  ) {
    return '';
  }

  return (
    <div className="load-more-button-wrapper">
      <input
        type="text"
        name={`${pluginNamespace}[page]`}
        hidden
        readonly
        ref={paginationInputEl}
      />
      <button
        className="btn btn--primary"
        type="button"
        onClick={handleLoadMoreClick}
      >
        <span>
          {labels.pagination.loadMore}
          <svg
            className="svg-chevron-down"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <path
              fill="currentColor"
              d="M 7,8.167306 12.444903,2.722403 14,4.2775 l -7,7 -7,-7 1.5550972,-1.555097 z"
            />
          </svg>
        </span>
      </button>
    </div>
  );
};

export default Pagination;
